var map = {
	"./da-DK": [
		"./locales/translated/da-DK.json",
		"i18n/da-DK"
	],
	"./da-DK.json": [
		"./locales/translated/da-DK.json",
		"i18n/da-DK"
	],
	"./de-DE": [
		"./locales/translated/de-DE.json",
		"i18n/de-DE"
	],
	"./de-DE.json": [
		"./locales/translated/de-DE.json",
		"i18n/de-DE"
	],
	"./es-LA": [
		"./locales/translated/es-LA.json",
		"i18n/es-LA"
	],
	"./es-LA.json": [
		"./locales/translated/es-LA.json",
		"i18n/es-LA"
	],
	"./fi-FI": [
		"./locales/translated/fi-FI.json",
		"i18n/fi-FI"
	],
	"./fi-FI.json": [
		"./locales/translated/fi-FI.json",
		"i18n/fi-FI"
	],
	"./fr-FR": [
		"./locales/translated/fr-FR.json",
		"i18n/fr-FR"
	],
	"./fr-FR.json": [
		"./locales/translated/fr-FR.json",
		"i18n/fr-FR"
	],
	"./it-IT": [
		"./locales/translated/it-IT.json",
		"i18n/it-IT"
	],
	"./it-IT.json": [
		"./locales/translated/it-IT.json",
		"i18n/it-IT"
	],
	"./ja-JP": [
		"./locales/translated/ja-JP.json",
		"i18n/ja-JP"
	],
	"./ja-JP.json": [
		"./locales/translated/ja-JP.json",
		"i18n/ja-JP"
	],
	"./ko-KR": [
		"./locales/translated/ko-KR.json",
		"i18n/ko-KR"
	],
	"./ko-KR.json": [
		"./locales/translated/ko-KR.json",
		"i18n/ko-KR"
	],
	"./nl-NL": [
		"./locales/translated/nl-NL.json",
		"i18n/nl-NL"
	],
	"./nl-NL.json": [
		"./locales/translated/nl-NL.json",
		"i18n/nl-NL"
	],
	"./no-NO": [
		"./locales/translated/no-NO.json",
		"i18n/no-NO"
	],
	"./no-NO.json": [
		"./locales/translated/no-NO.json",
		"i18n/no-NO"
	],
	"./pt-BR": [
		"./locales/translated/pt-BR.json",
		"i18n/pt-BR"
	],
	"./pt-BR.json": [
		"./locales/translated/pt-BR.json",
		"i18n/pt-BR"
	],
	"./ru-RU": [
		"./locales/translated/ru-RU.json",
		"i18n/ru-RU"
	],
	"./ru-RU.json": [
		"./locales/translated/ru-RU.json",
		"i18n/ru-RU"
	],
	"./sv-SE": [
		"./locales/translated/sv-SE.json",
		"i18n/sv-SE"
	],
	"./sv-SE.json": [
		"./locales/translated/sv-SE.json",
		"i18n/sv-SE"
	],
	"./tr-TR": [
		"./locales/translated/tr-TR.json",
		"i18n/tr-TR"
	],
	"./tr-TR.json": [
		"./locales/translated/tr-TR.json",
		"i18n/tr-TR"
	],
	"./zh-TW": [
		"./locales/translated/zh-TW.json",
		"i18n/zh-TW"
	],
	"./zh-TW.json": [
		"./locales/translated/zh-TW.json",
		"i18n/zh-TW"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./locales/translated lazy recursive ^\\.\\/.*$";
module.exports = webpackAsyncContext;